import React from "react";
import strings from "../../strings/";
import { getAbcyaUrl, getLangCode, language } from "../../config";

export default function LanguageMenu() {
  const languageCode = getLangCode();

  const renderContent = () => {
    return Object.keys(strings.footer.languageMenu).map((langKey) => {
      const stringValue = strings.footer.languageMenu[langKey];
      const url = new URL(`${getAbcyaUrl(langKey)}${language.resetHash}`);

      const setLangPreference = () => {
        try {
          window.localStorage.setItem(language.preferenceToken, langKey);
        } catch (e) {}
        window.location.replace(url);
      };

      return (
        <a data-testid={`footerLangLink_${langKey}`} role="link" key={stringValue} onClick={setLangPreference}>
          {stringValue}
        </a>
      );
    });
  };

  // remove temp logic when LA site goes live
  const tempProdLogic = process.env.NODE_ENV !== "production" || languageCode !== language.default;

  if (tempProdLogic) {
    return <>{renderContent()}</>;
  }

  return null;
}
